import NavigationRoutes from "@/projects/NPS/Stepper/utils/navigationRoutes";
import { useNavigate } from "react-router-dom";

const PaymentFailedScreen = ({
  amount = 0,
  txnRef = "",
  date = "",
}: {
  amount: number;
  txnRef: string;
  date: string;
}) => {
  const navigate = useNavigate();
  const OnDashboard = () => {
    navigate(NavigationRoutes.HOME);
  };
  const OnRetry = () => {
    navigate(NavigationRoutes.NEW_SUBSCRIBER_REGISTRATION);
  };
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-[#F2f2f2] p-3 py-5 md:px-4 md:py-10">
      {/* Payment Failed Alert Icon */}
      <div className="w-full max-w-xl rounded-[16px] border border-[#f2f2f2] bg-white p-3 shadow-[0_2px_24px_0_rgba(35,105,142,0.08)] md:p-6">
        <div className="mb-2 md:mb-4">
          <div className="mx-auto flex h-[80px] w-[80px] items-center justify-center rounded-full bg-[#FFDEDE] md:h-[100px] md:w-[100px]">
            <img
              src="/assets/error.svg"
              alt="Payment Failed"
              className="h-[45px] w-[45px] md:h-[55px] md:w-[55px]"
            />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-center font-sans text-[20px] font-bold text-[#000] md:text-[28px]">
          Payment Failed
        </h1>

        {/* Subtitle */}
        <p className="mx-auto mt-1 max-w-lg text-center font-sans text-[16px] font-semibold text-[#2F363F] md:text-[20px]">
          We couldn’t process your payment
        </p>

        <p className="mx-auto mt-2 max-w-xl text-center font-sans text-[16px] font-semibold leading-relaxed text-[#707070]">
          Your payment attempt is pending confirmation from the payment gateway.
          Please wait for the gateway response or try again.
        </p>

        {/* Card */}
        <div className="mt-4 w-full max-w-2xl rounded-xl border border-[#E5E7EB] bg-white p-3 shadow-md md:mt-6 md:p-6">
          <h2 className="mb-4 font-sans text-[20px] font-semibold text-[#2F363F]">
            Payment Details
          </h2>

          <div className="space-y-3 text-[16px]">
            <div className="flex justify-between">
              <span className="font-sans font-semibold text-[#2F363F]">
                Merchant
              </span>
              <span className="font-sans font-semibold text-[#707070]">
                NPSTrust — eNPS
              </span>
            </div>

            <div className="flex justify-between">
              <span className="font-sans font-semibold text-[#2F363F]">
                Amount
              </span>
              <span className="font-sans font-semibold text-[#707070]">
                ₹{amount}
              </span>
            </div>

            <div className="flex justify-between">
              <span className="font-sans font-semibold text-[#2F363F]">
                Date
              </span>
              <span className="font-sans font-semibold text-[#707070]">
                {date}
              </span>
            </div>

            <div className="flex justify-between">
              <span className="font-sans font-semibold text-[#2F363F]">
                Transaction Reference
              </span>
              <span className="font-sans font-semibold text-[#707070]">
                {txnRef}
              </span>
            </div>
          </div>

          {/* Red Message Box */}
          <div className="mt-5 rounded-lg border border-red-300 bg-red-50 p-3">
            <p className="font-sans text-[15px] font-medium leading-relaxed text-red-700">
              The response from the Payment Gateway for the payment attempt
              against this acknowledgement number is awaited. We request you to
              wait or re-try the payment process for registration in NPS.
            </p>
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-5 flex flex-col justify-center gap-3 md:mt-8 md:flex-row">
          <button
            onClick={OnRetry}
            className="text-md h-[45px] rounded-md border border-[#2F363F] px-5 py-2 font-sans font-semibold text-[#2F363F] hover:bg-[#f5f5f5]"
          >
            ↻ Retry Payment
          </button>

          <button
            onClick={OnDashboard}
            className="text-md h-[45px] rounded-md border border-[#2F363F] px-5 py-2 font-sans font-semibold text-[#2F363F] hover:bg-[#f5f5f5]"
          >
            ⬅ Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailedScreen;
